// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "js/sso" + "." + "b726bdb8976aff3040d8" + ".js";
};